import { Injectable, Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "filter",
	standalone: false
})
@Injectable()
export class FilterPipe implements PipeTransform {
	transform(items: any[], value: string): any[] {
		if (!items) {
			return [];
		}
		if (!value && value !== "") {
			return items;
		}

		return items.filter(singleItem => /* keys */ Object.keys(singleItem).some(key => singleItem[key] && singleItem[key].toLowerCase ? singleItem[key].toLowerCase().includes(value.toLowerCase()) : false));
	}
}